<template>
  <a-popover
    :placement="placement"
    :title="false"
    :overlayClassName="
      bodyclick ? 'onboarding_popover animated shake' : 'onboarding_popover'
    "
    :visible="visible"
    trigger="click"
  >
    <template slot="content">
      <slot name="content"></slot>
      <div slot="actions" class="step-actions" v-if="!hideActions">
        <div class="step-text">{{ step + 1 }} {{ $t("from") }} 3</div>
        <a-button
          class="step-ok-btn step-skip-all-btn"
          @click="closeStep(true)"
        >
          {{ $t("Skip all") }}
        </a-button>
        <a-button class="step-ok-btn" @click="closeStep(false)">{{
          $t("good")
        }}</a-button>
      </div>
    </template>
    <slot name="trigger"></slot>
  </a-popover>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    step: {
      type: Number,
      required: true,
    },
    placement: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    dicomWarning: {
      type: Boolean,
      required: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["bodyclick", "user"]),
  },
  methods: {
    preventFinishOnboarding() {
      this.$root.$emit("closeAllOnboardings");
      this.$debug(
        "Юзер кликнул на крестик. Онбординг принудительно завершен",
        "warning"
      );
      this.$root.finishOnboarding();
    },
    closeStep(finish) {
      this.$debug("ОНБОРДИНГ: шаг " + this.step + " завершен", "warning");
      this.$root.$emit("hideOnboarding", this.step);
      localStorage[
        "step" + this.step + "_approve_" + this.user.username
      ] = true;
      if (!finish) {
        this.$root.checkFinishOnboarding();
      } else {
        this.preventFinishOnboarding();
      }
    },
  },
};
</script>
